import type { ReactNode } from "react";

import { TooltipProvider } from "@/components/ui/tooltip";

// One TooltipProvider for every tooltip of a table (dates, desktop version),
// instead of one per cell: the all users tab renders up to 300 rows.
//
// The timing is set here on purpose rather than inherited. Without a provider
// of their own the tooltips would take SidebarProvider's (delayDuration 0) and
// open with no wait. 700 ms is what each per-cell provider used (Radix's
// default). skipDelayDuration 0 because a shared provider otherwise opens the
// next cell's tooltip instantly when the pointer moves on within 300 ms, while
// per-cell providers made every cell wait its 700 ms.
const TableTooltipProvider = ({ children }: { children: ReactNode }) => (
  <TooltipProvider delayDuration={700} skipDelayDuration={0}>
    {children}
  </TooltipProvider>
);

export default TableTooltipProvider;
